export const ActionTypes = {
  REQUEST: "FETCH_LIST_TASKS_REQUEST",
  SUCCESS: "FETCH_LIST_TASKS_SUCCESS",
  FAILURE: "FETCH_LIST_TASKS_FAILURE"
}
